export default __webpack_public_path__ + "static/media/blog5.d112587b.svg";